import type { DMAcceptorStartBlocker } from '@nsftx/systems-sdk'

/**
 * Blockers DM expects the client to act on: stop when present, start when not.
 * Other blockers are left to DM runtime.
 */
const BLOCKERS_ACTED: DMAcceptorStartBlocker[] = [
  'doors_open',
  'network_problem',
  'printer_problem',
  'login_data_reject_money'
]

/**
 * Blockers that DM will reject Start for. Sending AllAcceptorsStart is useless
 * while any of these are present.
 * `faulty_acceptor` is known by locales but not yet in the SDK union.
 */
const BLOCKERS_NON_IGNORABLE: readonly string[] = [
  'bill_disabled_on_dm',
  'coin_disabled_on_dm',
  'money_manager_unavailable',
  'faulty_acceptor'
]

const hasBlockersFromActedList = (blockers: DMAcceptorStartBlocker[]): boolean =>
  blockers.some((blocker) => BLOCKERS_ACTED.includes(blocker))

const hasNonIgnorableBlockers = (blockers: DMAcceptorStartBlocker[]): boolean =>
  blockers.some((blocker) => BLOCKERS_NON_IGNORABLE.includes(blocker))

export { BLOCKERS_ACTED, BLOCKERS_NON_IGNORABLE, hasBlockersFromActedList, hasNonIgnorableBlockers }
